
import { Vue } from "vue-class-component";

export default class Backlog extends Vue {}
